export var DeflistNode;
(function (DeflistNode) {
    DeflistNode["List"] = "dl";
    DeflistNode["Term"] = "dt";
    DeflistNode["Desc"] = "dd";
})(DeflistNode || (DeflistNode = {}));
